.list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 405px;
}

.list--bottom-border {
    border-bottom: 1px solid var(--off-white-dk);
}

.list--short {
    composes: list;
    height: 300px;
}

.list--fit-content {
    height: fit-content;
}

/* We need this to ensure the select dropdown renders above
 * all list items with an avatar (Some aspects of the Avatar component
 * have a z-index of 10)
 */
.select-container {
    z-index: 11;
    position: relative;
}
